import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { AlertController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";
import { Subscription } from "rxjs";
import { auditTime, distinctUntilChanged } from "rxjs/operators";
import * as fromApp from "../../../../../../store/app.reducer";
import * as selectors from "../../../../../../store/app.selectors";

@Component({
  selector: "app-quantity-image-checkbox-choice",
  templateUrl: "./quantity-image-checkbox-choice.component.html",
  styleUrls: ["./quantity-image-checkbox-choice.component.scss"],
})
export class QuantityImageCheckboxChoiceComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() selectedProductId: any;
  @Input() bundleMode: any;
  @Input() option_id;
  @Input() choice_id;
  @Input() selectedProductPromo: any;
  @Input() alt_dinein_active: any;
  @Input() selectedProductCategory: any;
  @Input() groupStoreData: any;
  @Input() imagePath;
  @Output() choiceChanged = new EventEmitter();

  public showChoicePrices: boolean = true;
  public selectedProduct: any;
  public option: any;
  public choice;
  public orderPickup;
  public dineIn;
  public selectedDineInTable;
  public showQuantityComponent: boolean;

  private optionSubscription: Subscription;
  private subscription: Subscription;

  constructor(
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private store: Store<fromApp.AppState>
  ) {}

  selectOption() {
    if (this.optionSubscription) {
      this.optionSubscription.unsubscribe();
    }
    this.optionSubscription = this.store
      .select(
        selectors.getOptionByOptionId(this.selectedProductId, this.option_id)
      )
      .pipe(distinctUntilChanged())

      .subscribe((state) => {
        if (!_.isEqual(this.option, state)) {
          this.option = _.cloneDeep(state);
          if (this.option && this.option.choices) {
            let choiceIndex = _.findIndex(this.option.choices, {
              choice_id: this.choice_id,
            });
            if (
              choiceIndex !== -1 &&
              !_.isEqual(this.choice, this.option.choices[choiceIndex])
            ) {
              this.choice = this.option.choices[choiceIndex];
              this.showQuantityElementDebounce();
            }
          }
        }
      });
  }

  ngOnInit() {
    this.subscription = this.store
      .select("deliveryMethodAddress")

      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (state && !_.isEqual(this.dineIn, state.dineIn)) {
          this.dineIn = _.cloneDeep(state.dineIn);
        }
        if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
          this.orderPickup = _.cloneDeep(state.orderPickup);
        }

        if (
          state &&
          !_.isEqual(this.selectedDineInTable, state.selectedDineInTable)
        ) {
          this.selectedDineInTable = _.cloneDeep(state.selectedDineInTable);
        }
      });
    this.selectOption();
    // this.store
    //   .select("selectedProduct")
    //   .pipe(distinctUntilChanged())
    //   .subscribe((state) => {
    //     if (
    //       state &&
    //       state.selectedProduct &&
    //       !_.isEqual(this.selectedProduct, state.selectedProduct)
    //     ) {
    //       this.selectedProduct = _.cloneDeep(state.selectedProduct);
    //       if (state.selectedProduct.options && this.option_id) {
    //         let optionInx = _.findIndex(this.selectedProduct.options, {
    //           option_id: this.option_id,
    //         });
    //         console.log("option from no quantity", optionInx);
    //         if (
    //           state.selectedProduct.options &&
    //           optionInx !== -1 &&
    //           !_.isEqual(state.selectedProduct.options[optionInx], this.option)
    //         ) {
    //           this.option = _.cloneDeep(
    //             state.selectedProduct.options[optionInx]
    //           );
    //           console.log("option from no quantity", this.option);
    //           if (
    //             state.selectedProduct.options[optionInx].choices &&
    //             this.choice_id
    //           ) {
    //             let choiceInx = _.findIndex(
    //               state.selectedProduct.options[optionInx].choices,
    //               {
    //                 choice_id: this.choice_id,
    //               }
    //             );
    //             console.log("choice index from no quantity", choiceInx);
    //             if (
    //               choiceInx !== -1 &&
    //               !_.isEqual(
    //                 this.choice,
    //                 state.selectedProduct.options[optionInx].choices[choiceInx]
    //               )
    //             ) {
    //               this.choice = _.cloneDeep(
    //                 state.selectedProduct.options[optionInx].choices[choiceInx]
    //               );
    //             }
    //           }
    //         }
    //       }
    //     }
    //   });
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (
      simpleChange &&
      simpleChange.option_id &&
      simpleChange.option_id.currentValue !==
        simpleChange.option_id.previousValue
    ) {
      this.selectOption();
    }
  }

  onCheckboxChanged(ev) {
    if (document.activeElement.tagName === "ION-CHECKBOX") {
      if (
        this.option &&
        this.option.freeChoices &&
        this.option.freeChoicesBySelectionOrder
      ) {
        if (this.choice.is_preselected) {
          this.choice.selected_timestamp = Date.now().toString();
        } else {
          delete this.choice.selected_timestamp;
        }
      }

      this.choiceChanged.emit(this.choice);
    }
  }

  showQuantityElementDebounce = _.debounce(() => {
    this.showQuantityComponent = true;
  }, 120);

  choiceQuantityDecrease() {
    var qtyStep = this.choice.quantityInChoicesStep || 1;
    //test this
    // if (this.choice.quantity - qtyStep <= 0) {
    //   this.choice.is_preselected = false;
    // }
    console.log("qtyStep", qtyStep);
    if (
      this.choice.quantity > qtyStep &&
      this.choice.is_preselected &&
      this.choice.activeTotal &&
      this.choice.availableTotal
    ) {
      this.choice.quantity = this.choice.quantity - qtyStep;
      this.choiceChanged.emit(this.choice);
    }
  }

  changeChoiceQuantity(ev) {
    if (ev === "increase") {
      this.choiceQuantityIncrease();
    } else if (ev === "decrease") {
      this.choiceQuantityDecrease();
    }
  }

  choiceQuantityIncrease() {
    let qtyStep = this.choice.quantityInChoicesStep || 1;
    console.log("qtyStep", qtyStep);
    if (
      this.choice.is_preselected &&
      this.choice.activeTotal &&
      this.choice.availableTotal
    ) {
      if (this.checkMaximumChoices()) {
        console.log("mpika sto increase");
        this.choice.quantity = this.choice.quantity + qtyStep;
        this.choiceChanged.emit(this.choice);
      } else {
        this.presentAlert(
          this.translateService.instant(
            "product-details.options.checkbox-options.maximum-choices-allowed"
          )
        );
      }
    }
  }

  checkMaximumChoices() {
    //I need to calculate here the choice quantity!

    var optionsMaxChoices = parseInt(this.option.maxChoices);
    var counter = 0;

    if (!_.isNaN(optionsMaxChoices) && optionsMaxChoices > 0) {
      _.each(
        _.sortBy(this.option.choices, "price"),
        function (choice, key, list) {
          if (
            choice.is_preselected &&
            choice.activeTotal &&
            choice.availableTotal
          ) {
            counter = counter + choice.quantity;
          }
        }
      );
      console.log(counter, optionsMaxChoices);
      if (counter >= optionsMaxChoices) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  async presentAlert(message) {
    const alert = await this.alertCtrl.create({
      message: message,
      buttons: ["OK"],
    });

    await alert.present();
  }

  ngOnDestroy() {
    if (this.optionSubscription) {
      this.optionSubscription.unsubscribe();
    }
  }
}
